import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-applicant-ehms.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-applicant-ehms.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { CreateApplicationApplicantEhmsConstants } from "./create-application-applicant-ehms.constants";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { RecipientSelectService } from "../../../../../shared/components/recipient-select/shared/service/recipient-select.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AlertType } from "../../../../../shared/models/alert";
// TODO: @Lawrence - Done
// - htnl Lines 51 - 75 ????
// - do all the controls / labels for ApplicantAgent still need to be here? Are they required because we are using he default Recipient component
// - please check all TSLint warnings before committing code e.g. remove unused imports; check deprecated forms of .subscribe
// - Owners and Contacts are not required for Create Application -> must be optional - see comments on #11345
let CreateApplicationApplicantEhmsComponent = class CreateApplicationApplicantEhmsComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    recipientSelectService;
    aflaModuleStrategyService;
    appController;
    changeDetectorRefs;
    applicantFormControlName = CreateApplicationApplicantEhmsConstants.APPLICANT_FORMCONTROL_NAME;
    markApplicantDetailsAsNotApplicableLabel = CreateApplicationApplicantEhmsConstants.MARK_APPLICANT_DETAILS_AS_NOT_APPLICABLE_LABEL;
    markApplicantDetailsAsNotApplicableFormControlName = CreateApplicationApplicantEhmsConstants.MARK_APPLICANT_DETAILS_AS_NOT_APPLICABLE_FORMCONTROL_NAME;
    applicantForm;
    recipientList = [];
    applicantDisableFilterBy = true;
    applicantDisableAdd = true;
    applicantDisableEditing = false;
    applicantShowFields = true;
    applicantIsInternal = false;
    applicantGroups = [];
    applicantLabel = "Applicant";
    showApplicantDetails = false;
    constructor(createApplicationService, recipientSelectService, aflaModuleStrategyService, appController, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.recipientSelectService = recipientSelectService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
    }
    loadMetadata(stepMeta) {
        try {
            this.applicantGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.applicantGroup);
            this.changeDetectorRefs.detectChanges();
        }
        catch (e) {
            this.appController.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("applicantForm");
        form.clearValidators();
        this.applicantForm = form;
        if (this.applicantForm.get("markApplicantDetailsAsNotApplicable").value == true) {
            this.showApplicantDetails = true;
        }
    }
    onMarkApplicantDetailsAsNotApplicableChecked(event) {
        this.showApplicantDetails = event.currentTarget.checked;
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: RecipientSelectService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
CreateApplicationApplicantEhmsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-application-applicant-ehms",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationApplicantEhmsComponent);
export { CreateApplicationApplicantEhmsComponent };
